import { __read, __assign, __rest } from './../../external_lib/tslib/tslib.es6.js';
import React__default, { useState, useImperativeHandle } from 'react';
import classNames from './../../external_lib/classnames/index.js';
import HorizonText, { TextVariant } from '../../base/HorizonText/index.js';
import HorizonButton from '../../base/HorizonButton/index.js';
import { SideNavItemChip } from '../SideNav/index.js';
import HorizonTooltip from '../../base/HorizonTooltip/index.js';
import HorizonTour from '../../base/HorizonTour/index.js';
import Cancel from '../../assets/icons/jsx/Cancel.js';
import ChevronRight from '../../assets/icons/jsx/ChevronRight.js';
import Lock from '../../assets/icons/jsx/Lock.js';
import Menu from '../../assets/icons/jsx/Menu.js';
import Copy from '../../assets/icons/jsx/Copy.js';
import DiscoverApps$1 from '../../assets/icons/jsx/DiscoverApps.js';
import CssVariables from '../../theme/variables/CssVariables.js';
import { extractInitials, getActiveApp, copyTextToClipboard } from '../../utils/string.util.js';
import { getSideNavFilledIcon, getSideNavOutlineIcon } from '../../helpers/sideNavIcons/index.js';
import styles from '../../components/sublayouts/TopNavbar/index.module.scss.js';
import Popover from './../../external_lib/antd/es/popover/index.js';
import Avatar from './../../external_lib/antd/es/avatar/index.js';
import Divider from './../../external_lib/antd/es/divider/index.js';
import Tooltip from './../../external_lib/antd/es/tooltip/index.js';
import Card from './../../external_lib/antd/es/card/index.js';
import Empty from './../../external_lib/antd/es/empty/index.js';
function TopNavbar(_a) {
  var _b = _a.className,
    className = _b === void 0 ? '' : _b,
    _c = _a.leftBlock,
    leftBlock = _c === void 0 ? null : _c,
    _d = _a.centerBlock,
    centerBlock = _d === void 0 ? null : _d,
    _e = _a.rightBlock,
    rightBlock = _e === void 0 ? null : _e,
    leftBlockClassName = _a.leftBlockClassName,
    centerBlockClassName = _a.centerBlockClassName,
    rightBlockClassName = _a.rightBlockClassName,
    _f = _a.appLogo,
    appLogo = _f === void 0 ? null : _f,
    _g = _a.onMenuClick,
    onMenuClick = _g === void 0 ? undefined : _g,
    _h = _a.collapsed,
    collapsed = _h === void 0 ? false : _h,
    style = _a.style,
    _j = _a.v2,
    v2 = _j === void 0 ? false : _j,
    _k = _a.userPopoverRef,
    userPopoverRef = _k === void 0 ? null : _k,
    _l = _a.tourProps,
    tourProps = _l === void 0 ? {} : _l,
    restProps = __rest(_a, ["className", "leftBlock", "centerBlock", "rightBlock", "leftBlockClassName", "centerBlockClassName", "rightBlockClassName", "appLogo", "onMenuClick", "collapsed", "style", "v2", "userPopoverRef", "tourProps"]);
  return React__default.createElement("div", {
    className: classNames(styles.topNavbar, 'flex justify-between h-16 w-full bg-white', className),
    style: style
  }, React__default.createElement("div", {
    className: classNames(styles.leftBlock, leftBlockClassName, 'flex items-center')
  }, onMenuClick && React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: classNames(styles.menuIcon, 'px-[11px] w-[58px] h-full flex items-center justify-center flex-shrink-0 transition-[width, opacity] duration-300 overflow-hidden opacity-100', {
      '!w-0 !px-0 !opacity-0': v2 && !collapsed,
      'max-md:px-1 max-md:w-[48px]': v2 && collapsed
    }),
    style: {
      marginLeft: '1px'
    }
  }, React__default.createElement(Menu, {
    className: "text-up-black-80 p-2 box-content cursor-pointer flex-shrink-0 hover:bg-up-black-5 rounded",
    onClick: onMenuClick
  })), (!v2 || collapsed) && React__default.createElement(Divider, {
    type: "vertical",
    style: {
      borderColor: '#ccc',
      height: '30px',
      margin: '0'
    }
  })), appLogo && React__default.createElement("div", {
    className: classNames(styles.appLogo, 'flex items-center px-5 flex-shrink-0', {
      'max-md:px-3 md:px-5': v2
    })
  }, appLogo), leftBlock), centerBlock && React__default.createElement("div", {
    className: classNames(styles.centerBlock, centerBlockClassName, 'max-lg:hidden lg:flex items-center')
  }, centerBlock), React__default.createElement("div", {
    className: classNames(styles.rightBlock, rightBlockClassName, 'flex items-center')
  }, rightBlock, React__default.createElement(UserPopover, __assign({}, restProps, {
    ref: userPopoverRef
  }))), React__default.createElement(HorizonTour, __assign({}, tourProps)));
}
var UserPopover = React__default.forwardRef(function (_a, ref) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  var _m = _a.showProfileDetails,
    showProfileDetails = _m === void 0 ? true : _m,
    _o = _a.showBizLogo,
    showBizLogo = _o === void 0 ? true : _o,
    _p = _a.showUserInitials,
    showUserInitials = _p === void 0 ? false : _p,
    _q = _a.avatar,
    avatar = _q === void 0 ? null : _q,
    avatarProps = _a.avatarProps,
    popoverProps = _a.popoverProps,
    _r = _a.profile,
    profile = _r === void 0 ? {} : _r,
    _s = _a.onUserInfoClick,
    onUserInfoClick = _s === void 0 ? undefined : _s,
    _t = _a.showAppSwitcher,
    showAppSwitcher = _t === void 0 ? false : _t,
    _u = _a.showCopyBizId,
    showCopyBizId = _u === void 0 ? true : _u,
    _v = _a.onAppSwitcherClick,
    onAppSwitcherClick = _v === void 0 ? undefined : _v,
    _w = _a.onLogoutClick,
    onLogoutClick = _w === void 0 ? undefined : _w,
    _x = _a.additionalPopoverContent,
    additionalPopoverContent = _x === void 0 ? null : _x;
  var _y = __read(useState(false), 2),
    open = _y[0],
    setOpen = _y[1];
  var _z = __read(useState(false), 2),
    copy = _z[0],
    setCopy = _z[1];
  var elementRef = React__default.useRef(null);
  var hide = function () {
    setTimeout(function () {
      setOpen(false);
    }, 100);
  };
  useImperativeHandle(ref, function () {
    return {
      hide: hide,
      element: elementRef.current
    };
  }, [hide]);
  var handleOpenChange = function (newOpen) {
    setOpen(newOpen);
  };
  var handleUserInfoClick = function () {
    if (onUserInfoClick) {
      onUserInfoClick();
    }
    hide();
  };
  var handleAppSwitcherClick = function () {
    if (onAppSwitcherClick) {
      onAppSwitcherClick();
    }
    hide();
  };
  var handleLogoutClick = function () {
    if (onLogoutClick) {
      onLogoutClick();
    }
    hide();
  };
  var content = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return React__default.createElement("div", {
      className: classNames(styles.profilePopverContent, 'flex flex-col')
    }, React__default.createElement("div", {
      onClick: onUserInfoClick ? handleUserInfoClick : function () {
        return void 0;
      },
      className: classNames('p-4 flex items-center rounded-t-lg', {
        'cursor-pointer hover:bg-up-black-5': onUserInfoClick ? true : false
      })
    }, React__default.createElement(Avatar, __assign({
      size: 36,
      shape: "circle",
      className: "shrink-0",
      style: {
        backgroundColor: '#5468FF',
        verticalAlign: 'middle'
      }
    }, avatarProps), React__default.createElement(HorizonText, {
      className: "text-lg font-semibold"
    }, avatar || extractInitials(((_a = profile === null || profile === void 0 ? void 0 : profile.user) === null || _a === void 0 ? void 0 : _a.fullName) || ((_b = profile === null || profile === void 0 ? void 0 : profile.user) === null || _b === void 0 ? void 0 : _b.name) || ((_c = profile === null || profile === void 0 ? void 0 : profile.user) === null || _c === void 0 ? void 0 : _c.email) || ''))), React__default.createElement("div", {
      className: "mx-3 flex flex-col gap-1 grow justify-center"
    }, React__default.createElement(HorizonText, {
      variant: TextVariant.BODY1_SEMIBOLD,
      className: "!text-base/4"
    }, ((_d = profile === null || profile === void 0 ? void 0 : profile.user) === null || _d === void 0 ? void 0 : _d.fullName) || ((_e = profile === null || profile === void 0 ? void 0 : profile.user) === null || _e === void 0 ? void 0 : _e.name) || ((_f = profile === null || profile === void 0 ? void 0 : profile.user) === null || _f === void 0 ? void 0 : _f.email)), (((_g = profile === null || profile === void 0 ? void 0 : profile.user) === null || _g === void 0 ? void 0 : _g.fullName) || ((_h = profile === null || profile === void 0 ? void 0 : profile.user) === null || _h === void 0 ? void 0 : _h.name)) && React__default.createElement(HorizonText, {
      variant: TextVariant.BODY1,
      className: "text-up-black-50 leading-4"
    }, (_j = profile === null || profile === void 0 ? void 0 : profile.user) === null || _j === void 0 ? void 0 : _j.email)), onUserInfoClick && React__default.createElement("div", {
      className: "shrink-0"
    }, React__default.createElement(ChevronRight, {
      className: "text-up-black-30"
    }))), React__default.createElement("div", {
      className: "py-3 px-4"
    }, React__default.createElement("div", {
      className: "flex items-center"
    }, React__default.createElement("div", {
      className: "flex flex-col grow justify-center"
    }, React__default.createElement(HorizonText, {
      variant: TextVariant.BODY1_SEMIBOLD,
      className: "text-base"
    }, ((_k = profile === null || profile === void 0 ? void 0 : profile.biz) === null || _k === void 0 ? void 0 : _k.name) || ((_l = profile === null || profile === void 0 ? void 0 : profile.company) === null || _l === void 0 ? void 0 : _l.name)), React__default.createElement(HorizonText, {
      variant: TextVariant.BODY1_SEMIBOLD,
      className: "flex items-center text-up-black-50 leading-4"
    }, React__default.createElement(HorizonText, {
      inline: true,
      variant: TextVariant.BODY1,
      className: "text-up-black-50 leading-4 mr-1"
    }, "Business ID:"), ((_m = profile === null || profile === void 0 ? void 0 : profile.biz) === null || _m === void 0 ? void 0 : _m.id) || ((_o = profile === null || profile === void 0 ? void 0 : profile.company) === null || _o === void 0 ? void 0 : _o.upr_biz_id), showCopyBizId && React__default.createElement(Tooltip, {
      title: copy ? 'Copied!' : 'Copy Business ID',
      trigger: ['hover', 'focus'],
      rootClassName: classNames(styles.tooltip, 'text-xs'),
      arrow: false,
      placement: "right",
      mouseLeaveDelay: copy ? 0.3 : 0.1,
      color: copy ? CssVariables['--up-green-40'] : CssVariables['--up-black-60']
    }, React__default.createElement(Copy, {
      onClick: function () {
        var _a, _b;
        copyTextToClipboard(((_a = profile === null || profile === void 0 ? void 0 : profile.biz) === null || _a === void 0 ? void 0 : _a.id) || ((_b = profile === null || profile === void 0 ? void 0 : profile.company) === null || _b === void 0 ? void 0 : _b.upr_biz_id) || '');
        setCopy(true);
        setTimeout(function () {
          return setCopy(false);
        }, 1000);
      },
      className: "text-up-black-30 p-1 mx-1 box-content cursor-pointer rounded-sm hover:bg-up-black-5"
    }))))), showAppSwitcher && onAppSwitcherClick && React__default.createElement(HorizonButton, {
      type: "link",
      onClick: handleAppSwitcherClick,
      className: "p-0 mt-3 !no-underline text-sm !text-up-blue-40 h-fit"
    }, "Switch App")), additionalPopoverContent, onLogoutClick && React__default.createElement("div", {
      className: "py-3 px-4"
    }, React__default.createElement(HorizonButton, {
      type: "link",
      onClick: handleLogoutClick,
      className: "p-0 !no-underline text-sm !text-up-bright-red-50 h-fit"
    }, "Logout")));
  };
  return React__default.createElement(Popover, __assign({
    open: open,
    onOpenChange: handleOpenChange,
    content: content(),
    placement: "bottomRight",
    trigger: ['click'],
    arrow: false,
    rootClassName: styles.profilePopover,
    align: {
      offset: [0, 10]
    },
    zIndex: 1000
  }, popoverProps), React__default.createElement("div", {
    className: classNames('mx-3 px-2 flex items-center cursor-pointer max-w-[200px]'),
    ref: elementRef
  }, showBizLogo && React__default.createElement(Avatar, __assign({
    size: 36,
    shape: "square",
    className: "shrink-0 rounded-sm",
    src: ((_b = profile === null || profile === void 0 ? void 0 : profile.biz) === null || _b === void 0 ? void 0 : _b.logo) || ((_c = profile === null || profile === void 0 ? void 0 : profile.company) === null || _c === void 0 ? void 0 : _c.logo)
  }, avatarProps)), showUserInitials && React__default.createElement(Avatar, __assign({
    size: 36,
    shape: "circle",
    className: "shrink-0",
    style: {
      backgroundColor: '#5468FF',
      verticalAlign: 'middle'
    }
  }, avatarProps), React__default.createElement(HorizonText, {
    className: "text-lg font-semibold select-none"
  }, avatar || extractInitials(((_d = profile === null || profile === void 0 ? void 0 : profile.user) === null || _d === void 0 ? void 0 : _d.fullName) || ((_e = profile === null || profile === void 0 ? void 0 : profile.user) === null || _e === void 0 ? void 0 : _e.name) || ((_f = profile === null || profile === void 0 ? void 0 : profile.user) === null || _f === void 0 ? void 0 : _f.email) || ''))), showProfileDetails && React__default.createElement("div", {
    className: "mx-2 truncate"
  }, React__default.createElement(HorizonText, {
    variant: TextVariant.BODY1,
    className: "truncate leading-[19px]"
  }, ((_g = profile === null || profile === void 0 ? void 0 : profile.user) === null || _g === void 0 ? void 0 : _g.fullName) || ((_h = profile === null || profile === void 0 ? void 0 : profile.user) === null || _h === void 0 ? void 0 : _h.name) || ((_j = profile === null || profile === void 0 ? void 0 : profile.user) === null || _j === void 0 ? void 0 : _j.email)), React__default.createElement(HorizonText, {
    variant: TextVariant.BODY2,
    className: "text-up-black-50 truncate"
  }, ((_k = profile === null || profile === void 0 ? void 0 : profile.biz) === null || _k === void 0 ? void 0 : _k.name) || ((_l = profile === null || profile === void 0 ? void 0 : profile.company) === null || _l === void 0 ? void 0 : _l.name)))));
});
var DiscoverApps = React__default.forwardRef(function (_a, ref) {
  var _b = _a.apps,
    apps = _b === void 0 ? [] : _b,
    _c = _a.selectedApp,
    selectedApp = _c === void 0 ? [] : _c,
    onAppClick = _a.onAppClick,
    popoverProps = _a.popoverProps;
  var _d = __read(useState(false), 2),
    popoverOpen = _d[0],
    setPopoverOpen = _d[1];
  var _e = __read(useState(false), 2),
    tooltipOpen = _e[0],
    setTooltipOpen = _e[1];
  var hideTooltip = function () {
    setTooltipOpen(false);
  };
  var handleOpenTooltipChange = function (newOpen) {
    if (popoverOpen && newOpen) {
      return;
    }
    setTooltipOpen(newOpen);
  };
  var hideAppsPopover = function () {
    setTimeout(function () {
      setPopoverOpen(false);
    }, 50);
  };
  var handleOpenPopoverChange = function (newOpen) {
    setPopoverOpen(newOpen);
    if (newOpen && tooltipOpen) {
      hideTooltip();
    }
  };
  var handleAppClick = function (app) {
    if (onAppClick) {
      onAppClick(getActiveApp(app, []));
    }
    hideAppsPopover();
  };
  var renderContent = function () {
    return React__default.createElement(Card, {
      rootClassName: classNames(styles.cardContainer, 'rounded'),
      title: React__default.createElement(HorizonText, {
        className: "text-up-black-80 font-semibold",
        variant: TextVariant.HEADING5
      }, "All Apps"),
      extra: React__default.createElement(Cancel, {
        width: 16,
        height: 16,
        className: "text-up-black-80 p-2 hover:bg-up-black-5 rounded box-content cursor-pointer relative -right-2",
        onClick: hideAppsPopover
      })
    }, React__default.createElement("div", {
      className: "flex gap-4 flex-wrap"
    }, apps.map(function (app, i) {
      return React__default.createElement("div", {
        key: i,
        className: classNames('p-4 w-44 min-h-[160px] border border-solid border-neutral-200 rounded flex flex-col gap-2', {
          'border-up-blue-40 bg-up-blue-5 hover:bg-up-blue-5': app.key === (selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp[0]),
          'cursor-pointer hover:bg-up-black-5': !(app === null || app === void 0 ? void 0 : app.isLocked),
          'cursor-default hover:bg-up-black-0': app === null || app === void 0 ? void 0 : app.isLocked
        }),
        onClick: function () {
          return handleAppClick(app);
        }
      }, React__default.createElement("div", {
        className: "flex items-center justify-between"
      }, app.iconId ? React__default.createElement("div", {
        className: "flex items-center justify-center p-3 rounded bg-up-blue-7"
      }, app.key === (selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp[0]) ? getSideNavFilledIcon(app.iconId, {
        className: 'text-up-blue-40 w-5 h-5 box-content'
      }) : getSideNavOutlineIcon(app.iconId, {
        className: 'text-up-blue-40 w-5 h-5 box-content'
      })) : app.icon ? React__default.createElement("div", {
        className: "flex items-center justify-center p-3 rounded bg-up-blue-7"
      }, React__default.createElement("img", {
        className: "w-5 h-5 box-content",
        src: app.icon,
        alt: ""
      })) : null, app.isNew && React__default.createElement(SideNavItemChip, {
        text: "New",
        textColor: CssVariables['--up-black-0'],
        backgroundColor: CssVariables['--up-green-50']
      }), app.isBeta && React__default.createElement(SideNavItemChip, {
        text: "Beta",
        textColor: CssVariables['--up-black-0'],
        backgroundColor: CssVariables['--up-green-50']
      }), app.isLocked && React__default.createElement(Lock, {
        width: "15px",
        height: "15px",
        className: "text-up-black-40"
      })), React__default.createElement(HorizonText, {
        className: "text-up-black-80",
        variant: TextVariant.BODY1_SEMIBOLD
      }, app === null || app === void 0 ? void 0 : app.label), React__default.createElement(HorizonText, {
        className: "text-up-black-60",
        variant: TextVariant.BODY2
      }, app === null || app === void 0 ? void 0 : app.description));
    }), apps.length === 0 && React__default.createElement(Empty, {
      className: "px-20",
      image: Empty.PRESENTED_IMAGE_SIMPLE,
      description: "No apps found"
    })));
  };
  if (!apps.length) {
    return null;
  }
  return React__default.createElement(Popover, __assign({
    open: popoverOpen,
    onOpenChange: handleOpenPopoverChange,
    title: "",
    content: renderContent(),
    placement: "bottomLeft",
    arrow: false,
    trigger: ['click'],
    rootClassName: styles.discoverAppsPopover,
    align: {
      offset: [0, 10]
    },
    style: {
      minWidth: 300
    }
  }, popoverProps), React__default.createElement(HorizonTooltip, {
    open: tooltipOpen,
    onOpenChange: handleOpenTooltipChange,
    trigger: ['hover'],
    title: React__default.createElement(HorizonText, {
      className: "text-up-black-80 p-1",
      variant: TextVariant.BODY2_SEMIBOLD
    }, "All Apps"),
    placement: "bottom",
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0
  }, React__default.createElement("div", {
    className: classNames('flex items-center justify-center text-up-black-50 cursor-pointer p-2 mx-[6px] hover:bg-up-black-5 hover:text-up-black-60 box-content rounded shrink-0', {
      'bg-up-black-5 text-up-black-60': popoverOpen
    }),
    ref: ref
  }, React__default.createElement(DiscoverApps$1, null))));
});
var TopNavbarApps = React__default.forwardRef(function (_a, ref) {
  var _b = _a.apps,
    apps = _b === void 0 ? [] : _b,
    _c = _a.selectedApp,
    selectedApp = _c === void 0 ? [] : _c,
    onAppClick = _a.onAppClick;
  if (!apps.length) {
    return null;
  }
  return React__default.createElement("div", {
    className: "flex items-center max-md:gap-1 md:gap-3 mx-[6px]",
    ref: ref
  }, apps.map(function (app, i) {
    return React__default.createElement(HorizonTooltip, {
      trigger: ['hover'],
      key: i,
      title: React__default.createElement(HorizonText, {
        className: "text-up-black-80 p-1",
        variant: TextVariant.BODY2_SEMIBOLD
      }, app.label),
      placement: "bottom",
      mouseEnterDelay: 0,
      mouseLeaveDelay: 0
    }, app.iconId ? React__default.createElement("div", {
      className: classNames('flex items-center justify-center p-2 text-up-black-50 hover:bg-up-black-5 hover:text-up-black-60 rounded cursor-pointer', {
        '!hover:bg-up-blue-5 !bg-up-blue-5 !hover:text-up-blue-40 !text-up-blue-40': (selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp[0]) === app.key
      }),
      onClick: function () {
        return onAppClick === null || onAppClick === void 0 ? void 0 : onAppClick(getActiveApp(app, []));
      }
    }, (selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp[0]) === app.key ? getSideNavFilledIcon(app.iconId, {
      className: 'w-5 h-5 box-content'
    }) : getSideNavOutlineIcon(app.iconId, {
      className: 'w-5 h-5 box-content'
    })) : app.icon ? React__default.createElement("div", {
      className: classNames('flex items-center justify-center p-2 hover:bg-up-black-5 rounded cursor-pointer', {
        '!hover:bg-up-blue-5 !bg-up-blue-5': (selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp[0]) === app.key
      }),
      onClick: function () {
        return onAppClick === null || onAppClick === void 0 ? void 0 : onAppClick(getActiveApp(app, []));
      }
    }, React__default.createElement("img", {
      className: "w-5 h-5 box-content",
      src: app.icon,
      alt: ""
    })) : null);
  }));
});
export { DiscoverApps, TopNavbarApps, UserPopover, TopNavbar as default };
//# sourceMappingURL=index.js.map
